import { Owner } from '@types'

import { Service } from '@tino-frontend/adapters'

export type OwnerStartKycCheck = {
  company_id: string
  company_name: string
  company_document_number: string
  owner_natural_person_id: string
  owner_name: string
  owner_document_number: string
  phone_number: string
  supplier_id: string
  supplier_name: string
}

export type OwnerBiometricMessageInfo = {
  workflow_id: string
  supplier_name: string
  phone: string
}

export class ClientKycService {
  constructor(private readonly httpSupplier: Service) {}

  async getClientOwners(cnpj: string): Promise<Owner[]> {
    return await this.httpSupplier.get<Owner[], Owner[]>(
      `/v2/merchants/owners?document_number=${cnpj}`
    )
  }

  startOwnerKycCheck(
    input: OwnerStartKycCheck
  ): Promise<{ workflow_id: string }> {
    return this.httpSupplier.post('v2/kyc/start-owner-check', input)
  }

  sendBiometricsLink(data: OwnerBiometricMessageInfo): Promise<void> {
    return this.httpSupplier.post('v2/kyc/owner-message', data)
  }
}
